
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 738 537","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M479.026 290.188l-99.925 79.383a16.752 16.752 0 01-20.846 0l-99.925-79.383L22.518 536.255h692.32L537.002 350.68l-57.975-60.492zM.005 84.988v426.317l231.967-242.046L.005 84.988z"}}),_c('path',{attrs:{"d":"M.005 0v42.188l368.53 292.742.145-.113.146.113L737.351 42.188V0H.005zM737.351 511.305V84.988l-231.966 184.27L737.35 511.306z"}})])])
          )
        }
      }
    